import { lastSearchLib } from './lib';
import * as model from './model';

export const lastSearchHistory = {
  model,
  lib: {
    isLastSearch: lastSearchLib.isLastSearch,
  },
};
